module.exports = __webpack_public_path__ + "static/media/icon-polygon.e1543f99.svg";